import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { LocalStorageService } from '../storage/local-storage.service';
import { SESSION_STORAGE_KEY } from '../storage/storage.constant';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  // private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly localStorageService = inject(LocalStorageService);

  canActivate(): boolean | UrlTree {
    console.log('AuthGuard: Checking authentication...');

    const accessToken = this.localStorageService.getItem(SESSION_STORAGE_KEY.ACCESS_TOKEN);
    const isLoggedIn = !!accessToken;

    if (isLoggedIn) {
      console.log('AuthGuard: User is authenticated, allowing access');
      return true;
    }

    console.log('AuthGuard: User is not authenticated, redirecting to login');
    return this.router.createUrlTree(['/auth/login']);
  }
}
